import React from 'react';

export default () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_ddd_158_9036)">
      <rect x="5" y="28" width="24" height="24" rx="12" transform="rotate(-90 5 28)" fill="#007CAD" />
      <path d="M13 17.53L13.94 18.47L17 15.4167L20.06 18.47L21 17.53L17 13.53L13 17.53Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_ddd_158_9036" x="0" y="0" width="34" height="35" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_158_9036" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_158_9036" result="effect2_dropShadow_158_9036" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="effect2_dropShadow_158_9036" result="effect3_dropShadow_158_9036" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_158_9036" result="shape" />
      </filter>
    </defs>
  </svg>
);
